import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type { GetTechnologiesByToolIdDto, GetTechnologiesByToolIdResponse } from "./dto/get-technologies-by-tool-id.dto";

export const TechnologiesByToolEffectActions = {
  getTechnologiesByToolId: `${Entities.TechnologiesByTool}_getTechnologiesByToolId`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.TechnologiesByTool,
  initSchema,
  aliasName: DIContainerKeys.TechnologiesByToolService,
})
export class TechnologiesByToolService extends HttpService {
  @loader(Loaders.GetTechnologiesByToolIdLoader)
  @action(DIContainerKeys.TechnologiesByToolService)
  public *getTechnologiesByToolId(dto: GetTechnologiesByToolIdDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetTechnologiesByToolIdLoader, true);
    const response: GetTechnologiesByToolIdResponse = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetAllTechsByIntegration),
        params: {
          optionEnum1: dto.toolId,
        },
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetTechnologiesByToolIdLoader, false);
      return;
    }
    const { mr, ...payload } = response;
    yield this.setEntityStateById(Entities.TechnologiesByTool, dto.toolId, payload);
    yield this.setLoaderState(Loaders.GetTechnologiesByToolIdLoader, false);
  }
}

